var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomationIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#0095FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0505 18H14.5C13.1193 18 12 16.8807 12 15.5C12 14.1193 13.1193 13 14.5 13H24.0505M17.9495 29H27.5C28.8807 29 30 27.8807 30 26.5C30 25.1193 28.8807 24 27.5 24H17.9495M12 26.5C12 28.433 13.567 30 15.5 30C17.433 30 19 28.433 19 26.5C19 24.567 17.433 23 15.5 23C13.567 23 12 24.567 12 26.5ZM30 15.5C30 17.433 28.433 19 26.5 19C24.567 19 23 17.433 23 15.5C23 13.567 24.567 12 26.5 12C28.433 12 30 13.567 30 15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationIconActive);
export default __webpack_public_path__ + "static/media/automationIconActive.f2b2c24d504ac3c45dd8ccd9acafd4cb.svg";
export { ForwardRef as ReactComponent };